import React from "react";
import Icons from "./Icons";

export default function Footer() {
  return (
    <div className="relative bottom-0 w-full">
      <div className="copyright">
        <Icons className="social" />
        <p>Designed & Built with ❤️ by Nesrine Mrabet</p>
      </div>
    </div>
  );
}
